import { type Ref } from 'react';
import { IconButton, type IconButtonProps } from '@lingoda/ui/buttons/IconButton';
import { PlayAudioIcon24, type PlayAudioIconAnimation } from '@lingoda/ui/icons/PlayAudioIcon';
import { Box, type Theme, styled } from '@lingoda/ui';
import CircularProgress from '@lingoda/ui/feedback/CircularProgress';

export interface IconButtonAudioLayoutProps extends IconButtonProps {
    loading?: boolean;
    animationRef?: Ref<PlayAudioIconAnimation>;
}

export const IconButtonAudioLayout = (props: IconButtonAudioLayoutProps) => {
    const { loading, animationRef, ...passProps } = props;

    return (
        <IconButtonStyled {...passProps}>
            {props.loading ? <Loading /> : <PlayAudioIcon24 animationRef={animationRef} />}
        </IconButtonStyled>
    );
};

const IconButtonStyled = styled(IconButton)(({ theme }) => ({
    color: theme.palette.text.secondary,

    ':hover': {
        ...buttonHoverStyles({ theme }),
    },
})) as typeof IconButton;

export const buttonHoverStyles = ({ theme }: { theme: Theme }) => {
    return {
        color: theme.palette.primary.main,
    };
};

const Loading = () => {
    return (
        <Box display="inline-flex" p={0.5}>
            <CircularProgress color="inherit" size={16} />
        </Box>
    );
};
